import React from "react";

const NotificationIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.25 14.4375C11.25 15.0342 11.0129 15.6065 10.591 16.0285C10.169 16.4504 9.5967 16.6875 9 16.6875C8.4033 16.6875 7.83097 16.4504 7.40902 16.0285C6.98706 15.6065 6.75 15.0342 6.75 14.4375"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.18475 13.6874C3.81766 13.6094 3.49311 13.3968 3.27512 13.0913C3.05714 12.7859 2.96156 12.4098 3.00726 12.0374L3.75726 5.95486C3.94875 4.70435 4.58534 3.56502 5.54993 2.74649C6.51453 1.92795 7.74225 1.48528 9.00728 1.49986C10.2723 1.48528 11.5 1.92795 12.4646 2.74649C13.4292 3.56502 14.0658 4.70435 14.2573 5.95486L15.0073 12.0374C15.0533 12.4088 14.9587 12.7839 14.7422 13.0892C14.5258 13.3945 14.203 13.6079 13.8373 13.6874C10.663 14.4332 7.35902 14.4332 4.18475 13.6874Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NotificationIcon;
